module.exports = __webpack_public_path__ + "movable.570d243.png";